import { AspectRatio, Box, BoxProps } from '@mantine/core'

import { NextImageWrap } from 'components/atoms/imageWrap'
import { useIsMobile } from 'hooks/useIsMobile'
import { ScheduleEventCard } from 'interfaces/types'

import useStyles from './index.styles'

type EventCardProps = {
  item: ScheduleEventCard
  startCountdown?: boolean
} & BoxProps

export const EventCard = ({
  startCountdown,
  className,
  classNames,
  styles,
  item,
  ...boxProps
}: EventCardProps) => {
  const { title, state, bannersDesktop, bannersMobile } = item
  const isMobile = useIsMobile()
  const { classes, cx } = useStyles(undefined, {
    name: 'ScheduleEvent__EventCard',
    styles,
    classNames,
  })

  return (
    <Box
      data-status={state}
      className={cx(className, classes.root, 'event-card')}
      {...boxProps}
    >
      <AspectRatio
        ratio={isMobile ? 1 : 664 / 206}
        className={cx('thumb-frame', classes.thumbFrame)}
      >
        <NextImageWrap
          src={isMobile ? bannersMobile : bannersDesktop}
          alt={title || ''}
          loading="lazy"
          className={classes.thumbImg}
          fill
        />
      </AspectRatio>
    </Box>
  )
}
